import { Component } from '@angular/core';
import { ATableMenuTab } from './mactable.menu.tab';

@Component({
    selector: 'mactable-sum-menu-tab',
    templateUrl: './sum.menu.tab.html'
})
export class MacTableSumMenuTab extends ATableMenuTab {
}
